<img id="main-img" class="scale" src="assets/imagem-topo.png" alt="" />
